import React from "react";
import PropTypes from "prop-types";
import Checkbox from "./Checkbox";

export default class ReduxCheckbox extends React.Component {
    onChange = (value) => {
        this.props.input.onChange(value);
    };

    render() {
        const {
            label,
            id,
            input: {value},
            required,
            disabled,
            allowedValue,
            margin,
            className,
            inverted,
        } = this.props;
        return (
            <Checkbox
                margin={margin}
                allowedValue={allowedValue}
                label={label}
                disabled={disabled}
                className={className}
                checked={inverted ? !value : value}
                required={required}
                onChange={(value) => this.onChange(inverted ? !value : value)}
                id={id}
            />
        );
    }
}

ReduxCheckbox.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.node,
    ]).isRequired,
    id: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
};
